interface ILeadsMapOptions {
  container: string,
  lat: string,
  lng: string,
}

export class LeadsMap {
  /* Класс для управления картами на странице продуктов
  */

  constructor(options: ILeadsMapOptions) {
    this.addMapToPage(options)
  }

  private addMapToPage(options: ILeadsMapOptions): void {
    ymaps.ready(() => {
      const map = new ymaps.Map(options.container, {
        center: [options.lat, options.lng],
        zoom: 13,
      })

      const mark = new ymaps.Placemark(
        [options.lat, options.lng],
        {},
        {},
      )

      map.geoObjects.add(mark)
    })
  }
}
